// extracted by mini-css-extract-plugin
export default {"container":"TapText_container__VuIts","label":"TapText_label__Ipi1Z","buttonContainer":"TapText_buttonContainer__e5Ddr","button":"TapText_button__Phk-R"};